import {AxiosResponse} from 'axios';
import {axiosInstance} from '..';

export function getEvaluation(): Promise<AxiosResponse<any, any>> {
    return axiosInstance.get(`Evaluation/List`, {
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
    });
}

export function getEvaluationSupplier(id: string): Promise<AxiosResponse<any, any>> {
  return axiosInstance.get(`Evaluation/GetEvaluationSupplier/${id}`, {
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json',
    },
  });
}
export function getLastEvaluations(
  supplierCodes: string[] = [],
  supplierNames: string[] = [],
  startDate?: string | null,
  endDate?: string | null,
  categoryId?: number,
  page: number = 1,
  pageSize: number = 10
  ): Promise<AxiosResponse<any, any>> {
  const params = new URLSearchParams();
  
  supplierCodes.forEach(code => {
    params.append('supplierCodes', code);
  });
  
  supplierNames.forEach(name => {
    params.append('supplierNames', name);
  });

  if (startDate) {
    params.append('startDate', startDate);
  }
  if (endDate) {
    params.append('endDate', endDate);
  }

  if (categoryId) {
    params.append('categoryId', categoryId.toString());
  }
  params.append('page', page.toString());
  params.append('pageSize', pageSize.toString());
  
  return axiosInstance.get(`Evaluation/LastEvaluations?${params.toString()}`, {
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json',
    },
  });
}

export function uploadEvaluationsExcel(file): Promise<AxiosResponse<any, any>> {
  const formData = new FormData();
  formData.append('file', file);
  
  return axiosInstance.post('Evaluation/upload-excel', formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
}

export function softDeletePreEvaluations(evaluationsIds: number[]): Promise<AxiosResponse<any, any>> {
  const requestBody = {
    EvaluationIds: evaluationsIds.map(id => ({ id })) 
  };
  
  
  return axiosInstance.put('Evaluation/SoftdeleteEvaluations', requestBody, {
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json',
    },
  });
}

//descargar últimas evaluaciones
// export function downloadLastEvaluations(evaluationIds: number[]): Promise<AxiosResponse<Blob>> {
//   // Cambia a POST y ajusta la estructura de datos
//   return axiosInstance.post('Evaluation/DownloadLastEvaluations', {
//     evaluationIds: evaluationIds.map(id => ({ id }))
//   }, {
//     headers: {
//       'Content-Type': 'application/json',
//     },
//     responseType: 'blob'
//   });
// }
//descargar últimas evaluaciones
export async function downloadLastEvaluations(): Promise<void> {
  try {
    const response = await axiosInstance.post('Evaluation/DownloadLastEvaluations', 
      {}, 
      {
        responseType: 'blob'
      }
    );

    const contentDisposition = response.headers['content-disposition'];
    let fileName = 'Evaluaciones_de_proveedores.xlsx';
    
    if (contentDisposition) {
      const fileNameMatch = contentDisposition.match(/filename="?([^"]+)"?/);
      if (fileNameMatch?.[1]) {
        fileName = fileNameMatch[1].split(';')[0].trim();
      }
    }

    const url = window.URL.createObjectURL(response.data);
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', fileName);
    document.body.appendChild(link);
    link.click();
    
    setTimeout(() => {
      link.parentNode?.removeChild(link);
      window.URL.revokeObjectURL(url);
    }, 100);
  } catch (error) {
    console.error('Error en downloadLastEvaluations:', error);
    throw error;
  }
}

export function downloadEvaluationTemplate(): Promise<void> {
  return axiosInstance.get(`Criterion/ExportExcel`, {
    responseType: 'blob',
  }).then(response => {
    const contentDisposition = response.headers['content-disposition'];
    let fileName = 'Plantilla_evaluacion.xlsx'; 

    
    if (contentDisposition) {
      const standardMatch = contentDisposition.match(/filename="?([^;"]+)"?/);
      const utf8Match = contentDisposition.match(/filename\*=UTF-8''([^;]+)/);
      
      if (standardMatch && standardMatch[1]) {
        fileName = standardMatch[1].replace(/["']/g, '');
      } else if (utf8Match && utf8Match[1]) {
        fileName = decodeURIComponent(utf8Match[1]);
      }
    }

    fileName = fileName.split(';')[0].trim();

    const url = window.URL.createObjectURL(new Blob([response.data]));
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', fileName);
    document.body.appendChild(link);
    link.click();
    
    link.parentNode?.removeChild(link);
    window.URL.revokeObjectURL(url);
  });
}
// export function downloadEvaluationTemplate(): Promise<void> {
//   return axiosInstance.get(`Criterion/ExportExcel`, {
//     responseType: 'blob',
//   }).then(response => {
//     const contentDisposition = response.headers['content-disposition'];
//     let fileName = 'Plantilla_de_evaluación.xlsx';

//     // Manejo avanzado del Content-Disposition (soporta filename y filename*)
//     if (contentDisposition) {
//       const utf8FilenameMatch = contentDisposition.match(/filename\*=UTF-8''(.+)/);
//       if (utf8FilenameMatch) {
//         // Decodificar el nombre codificado en UTF-8 (ej: %20 → espacio)
//         fileName = decodeURIComponent(utf8FilenameMatch[1]);
//       } else {
//         // Fallback: buscar el formato tradicional filename="..."
//         const filenameMatch = contentDisposition.match(/filename="?(.+)"?/);
//         if (filenameMatch && filenameMatch.length > 1) {
//           fileName = filenameMatch[1].replace(/['"]/g, ''); // Eliminar comillas si las hay
//         }
//       }
//     }

//     // Crear el Blob y el enlace de descarga
//     const blob = new Blob([response.data], { type: response.headers['content-type'] });
//     const url = window.URL.createObjectURL(blob);
//     const link = document.createElement('a');
//     link.href = url;

//     link.setAttribute('download', fileName.trim()); // Asegurar que no haya espacios
//     document.body.appendChild(link);
//     link.click();

//     // Limpieza
//     link.parentNode?.removeChild(link);
//     window.URL.revokeObjectURL(url);
//   });
// }

//subir plan de trabajo - proveedor
export function sendWorkPlanMail(file: File, supplierId: string, email: string): Promise<AxiosResponse<any, any>> {
  const formData = new FormData();
  formData.append('file', file);
  formData.append('supplierId', supplierId);
  formData.append('email', email);
  
  return axiosInstance.post('Evaluation/SendWorkPlanMail', formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
}

//correo de confirmación de envío de evaluación

export function sendConfirmEvaluation(
  evaluationsWithoutObservations: number[],
    evaluationsWithObservations: number[] = []
): Promise<AxiosResponse<Blob>> {
  return axiosInstance.post('Evaluation/SendConfirmEvaluation', {
    evaluationsWithoutObservations: evaluationsWithoutObservations.map(id => ({ id })),
    evaluationsWithObservations: evaluationsWithObservations.map(id => ({ id }))
  }, {
    headers: {
      'Content-Type': 'application/json',
    },
    responseType: 'blob'
  });
}

//numero de intentos restantes
export function remmainingAttempts(supplierId: string): Promise<AxiosResponse<any, any>> {
    return axiosInstance.get(`Evaluation/RemmainingAttempts/${supplierId}`, {
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
    });
}

export function searchSuppliersByCode(searchTerm: string, limit: number = 100): Promise<AxiosResponse<any, any>> {
    return axiosInstance.get(`Evaluation/SearchByCode?searchTerm=${encodeURIComponent(searchTerm)}&limit=${limit}`, {
        headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json',
        },
    });
}

export function searchSuppliersByName(searchTerm: string, limit: number = 100): Promise<AxiosResponse<any, any>> {
    return axiosInstance.get(`Evaluation/SearchByName?searchTerm=${encodeURIComponent(searchTerm)}&limit=${limit}`, {
        headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json',
        },
    });
}